import { useCallback } from "react";
import { useNavigate } from "react-router-dom";

const useCustomNavigate = () => {
    const navigate = useNavigate();

    const goTo = (path, options = {}) => {
        // Perform additional logic if needed before navigation
        if (!path) {
            console.error("Path is required for navigation.");
            return;
        }

        // Navigate to the specified path with options
        navigate(path, options);
    };


     // This function handles the navigation to a new tab
  const goToNewTab = useCallback((url) => {
    window.open(url, '_blank'); // '_blank' opens the link in a new tab
  }, []);

    return { goTo,goToNewTab };
};

export default useCustomNavigate;
